import { render } from "./hpPromise.vue?vue&type=template&id=a977acfc&scoped=true"
import script from "./hpPromise.vue?vue&type=script&lang=js"
export * from "./hpPromise.vue?vue&type=script&lang=js"

import "./hpPromise.vue?vue&type=style&index=0&id=a977acfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a977acfc"]])

export default __exports__